<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="col-md-5">
              <h5>Add a single User or multiple</h5>
              <br>
              <div class="list-group">
                <router-link :to="'/admin/user/create/' + element.url" class="list-group-item device" v-for="element in userOptions">
                  <div class="d-flex w-100 justify-content-between">
                    <p style="font-size:25px">{{element.name}}</p>
                  </div>
                  <small>{{element.description}}</small>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextArea from '../../elements/Form/FormTextArea'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createdevice',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea
  },
  data () {
    return {
      userOptions:[
        {name:"Create Single User",description:"Add a single user where you can select their role.",url:"singleuser"}, 
        {name:"Create Multiple Users",description:"Add a list of users.",url:"multipleusers"}
      ],
      selectedDevice: {}
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.device p{
  color: #000
}
.device small{
  color: #000
}
.device:hover {
    z-index: 2;
    color: #fff;
    background-color: #46B3E4;
    border-color: #46B3E4;
}
.device:hover p {
  color: #fff
}
.device:hover small {
  color: #fff
}
</style>



// WEBPACK FOOTER //
// CreateUser.vue?1d989ee9